import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DashboardComponent } from './components/dashboard/dashboard.component'
import { DtoModule } from '../dto/dto.module'
import { DirectivesModule } from '../directives/directives.module'

@NgModule({
  declarations: [DashboardComponent],
  imports: [CommonModule, DtoModule, DirectivesModule],
  exports: []
})
export class DashboardModule {}
